<template>
  <main class="wrapper">

    <navigation-componenet></navigation-componenet>

    <header-componenet :show-header="show_header"
                       v-show="['main'].indexOf($route.name) > -1">
    </header-componenet>

    <router-view
      class="view"
      keep-alive
      transition
      transition-mode="out-in">
    </router-view>

    <!-- <header-componenet v-show="$root.currentPage === 'home'" :show-header="show_header"></header-componenet>

    <files-componenet v-show="!show_header && $root.currentPage === 'home'" :show-header.sync="show_header"></files-componenet>

    <component v-if="$root.currentPage !== 'home'" :is="$root.currentPage"></component> -->
  </main>
</template>

<script>

import Navigation from './components/Navigation';
import Header from './components/Header';
import config from '../config/app';

export default {
  data () {
    return {
      show_header: true,
      config: config
    };
  },
  components: {
    'navigation-componenet': Navigation,
    'header-componenet': Header
  }
};
</script>

<style scoped>

.fade-enter-active, .fade-leave-active {
  transition: all .2s ease;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}

</style>



/** WEBPACK FOOTER **
 ** App.vue?c11fe89e
 **/